import { ChangeDetectionStrategy, Component, Inject } from '@angular/core'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { SVG_ICON_SRC } from '../../../../../../injectors/svg-icon.injector'
import { NotificationSettingsModalComponent } from '../../modals/notification-settings-modal/notification-settings-modal.component'

@Component({
    selector: 'app-notification-settings',
    templateUrl: './notification-settings.component.html',
    styleUrls: ['./notification-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationSettingsComponent {
    constructor(
        private modalService: NgbModal,
        @Inject(SVG_ICON_SRC) public readonly svgDefaultSrc: string
    ) {}

    openNotificationSettingsModal(): void {
        this.modalService.open(NotificationSettingsModalComponent, { backdrop: 'static', keyboard: false })
    }
}
